import config from "../config";

const apiUrl = config.apiUrl;

export const getZipCodes = async () => {
  const response = await fetch(`${apiUrl}/zip-codes`);
  const data = await response.json();
  return data;
};
